module.exports = __webpack_public_path__ + "static/media/cappello.1f069df5.gif";